import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';

const HISTOGRAM_HEIGHT = 100;

const Histogram = ({
	values,
	facetId,
	bottomLimit,
	topLimit,
	currentMin,
	currentMax,
	bucketMap,
	bucketSize
}) => {
	const histogram = [];

	const histogramScale =
		HISTOGRAM_HEIGHT /
		Math.max(
			...values?.map((v) => {
				return v.count;
			})
		);

	for (let point = bottomLimit; point < topLimit; point += bucketSize) {
		// Create Histogram
		const height = bucketMap.has(point)
			? Math.round(histogramScale * bucketMap.get(point).count) + 10
			: 0;
		const activeClass =
			currentMin <= point && point < currentMax ? 'active' : '';
		histogram.push(
			<div
				key={`${facetId}-${point}`}
				id={`${facetId}-${point}`}
				className={setClassNames(['histogram-bar', activeClass])}
				style={{
					height
				}}
			/>
		);

		if (point === 1) {
			point = 0;
		}
	}
	return <div className="histogram">{histogram}</div>;
};

Histogram.propTypes = {
	values: PropTypes.arrayOf(
		PropTypes.shape({
			count: PropTypes.number.isRequired,
			label: PropTypes.string.isRequired,
			type: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired
		})
	).isRequired,
	facetId: PropTypes.string.isRequired,
	bottomLimit: PropTypes.number.isRequired,
	topLimit: PropTypes.number.isRequired,
	currentMin: PropTypes.number.isRequired,
	currentMax: PropTypes.number.isRequired,
	bucketMap: PropTypes.instanceOf(Map).isRequired,
	bucketSize: PropTypes.number.isRequired
};

export default Histogram;
